// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 22H2V2H22V22ZM4 20H7V7H20V4H4V20ZM10 14V16H16V14H10ZM10 10V12H18V10H10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-page-included-filled')
export default class PageIncludedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'page-included-filled',
    }
  }
}
